import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { aiActivity } from 'utils/aiActivity';

/**
 * Global "Key is working…" indicator, fixed to the top of the viewport so it shows on EVERY
 * page and device — independent of the chat widget or the current screen. This covers the
 * case where Key builds a report and then navigates the user (take_me_there / self-navigating
 * report tools): the report page's own spinner isn't on screen yet, so without this the user
 * sees a silent 30–45s stall. Driven by in-flight POST /AI calls via aiActivity.
 */
export default function GlobalAiActivity() {
  const [busy, setBusy] = useState(aiActivity.isBusy());
  useEffect(() => {
    setBusy(aiActivity.isBusy()); // resync in case it changed before we subscribed
    return aiActivity.subscribe(setBusy);
  }, []);

  if (!busy) return null;

  return (
    <Box
      role='status'
      aria-live='polite'
      sx={{
        position: 'fixed', top: 10, left: '50%', transform: 'translateX(-50%)', zIndex: 2001,
        display: 'flex', alignItems: 'center', gap: 1,
        // Light-gray pill with a green spinner + gray text — matches the "Asking Key…"
        // indicator and reads better than the old near-black background.
        bgcolor: 'grey.100', color: 'text.secondary',
        border: '1px solid', borderColor: 'divider',
        px: 1.5, py: 0.75, borderRadius: 2, boxShadow: 3,
        pointerEvents: 'none', userSelect: 'none', whiteSpace: 'nowrap',
      }}
    >
      <CircularProgress size={16} color='primary' />
      <Typography variant='body2' color='text.secondary'>Key is thinking…</Typography>
    </Box>
  );
}
